import { useState } from "react";
import { X, CreditCard } from "lucide-react";
import { toast } from "sonner";
import { startCedaPayment, euros } from "@/lib/ceda";

export const PayChoice = ({ order, onClose }) => {
  const [busy, setBusy] = useState("");
  const pay = async (provider) => {
    setBusy(provider);
    try {
      await startCedaPayment(provider, order.payload);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Paiement impossible pour le moment");
      setBusy("");
    }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <div data-testid="ceda-pay-modal" onClick={(e) => e.stopPropagation()} className="bg-white rounded-3xl p-7 max-w-md w-full animate-in fade-in zoom-in-95 duration-200">
        <div className="flex items-start justify-between">
          <div>
            <p className="font-ui text-xs tracking-[0.2em] text-[#C9A24B] uppercase">Votre commande</p>
            <h3 className="font-serif text-2xl text-[#1F2A24] mt-1">{order.label}</h3>
          </div>
          <button onClick={onClose} className="p-1.5 rounded-full hover:bg-[#F6F2E9]" data-testid="ceda-pay-close"><X size={18} /></button>
        </div>
        {order.names?.length > 0 && (
          <ul className="mt-4 space-y-1 font-sans text-sm text-[#1F2A24]/75" data-testid="ceda-pay-items">
            {order.names.map((n) => <li key={n}>· {n}</li>)}
          </ul>
        )}
        <p className="font-serif text-4xl text-[#385E3A] mt-5" data-testid="ceda-pay-total">{euros(order.cents)}</p>
        <p className="font-sans text-xs text-[#1F2A24]/60 mt-2">
          Vos capsules arrivent en attente dans « Mes CEDA ». Les 7 jours ne démarrent qu'au moment où vous cliquez sur « Activer ».
        </p>
        <div className="mt-6 grid gap-3">
          <button data-testid="ceda-pay-stripe" disabled={!!busy} onClick={() => pay("stripe")} className="inline-flex items-center justify-center gap-2 rounded-full bg-[#385E3A] text-white py-3.5 font-ui text-sm hover:bg-[#2c4a2e] disabled:opacity-60 transition-colors">
            <CreditCard size={16} /> {busy === "stripe" ? "Redirection…" : "Payer par carte"}
          </button>
          <button data-testid="ceda-pay-paypal" disabled={!!busy} onClick={() => pay("paypal")} className="rounded-full bg-[#003087] text-white py-3.5 font-ui text-sm font-semibold hover:bg-[#00256a] disabled:opacity-60 transition-colors">
            {busy === "paypal" ? "Redirection…" : "Payer avec PayPal"}
          </button>
        </div>
      </div>
    </div>
  );
};
